import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Checkbox from '@bibliocommons/base-checkbox';
import { FormattedMessage } from 'react-intl';
import StickyToolbar from '@bibliocommons/base-sticky-toolbar';

import './BatchActionsControls.scss';

export default function BatchActionsControls({ list, updateAll, selectedItems, sticky, children }) {
  const Tag = sticky ? StickyToolbar : 'div';
  return (
    <Tag>
      <div className="cp-batch-action-controls">
        <div className="master-checkbox">
          <FormattedMessage id="batch_action_select_items" values={{ count: list.size }}>
            {label => <Checkbox id="batch-actions-master" inline handleChange={updateAll} checked={selectedItems.size === list.size} label={label} />}
          </FormattedMessage>
        </div>
        <div className="action-buttons">{children}</div>
      </div>
    </Tag>
  );
}

BatchActionsControls.propTypes = {
  list: ImmutablePropTypes.list.isRequired,
  updateAll: PropTypes.func.isRequired,
  selectedItems: ImmutablePropTypes.map.isRequired,
  sticky: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

BatchActionsControls.defaultProps = {
  pageNumber: 1,
  pageLimit: 25,
  sticky: false
};



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchActionsControls/BatchActionsControls.jsx